module.exports = __webpack_public_path__ + "static/Organigramm 1-8cc85f801dc4c977cbf596b60363f293.jpg";